export default __webpack_public_path__ + "_/images/freespins/freespins-10-3f5e5697390b3a5a0dc3c12d140a92b2d6128991bda76707fb0a08ebf50f7536.png";